import { render, staticRenderFns } from "./PasswordForgot.vue?vue&type=template&id=40bba02e&scoped=true&"
import script from "./PasswordForgot.vue?vue&type=script&lang=js&"
export * from "./PasswordForgot.vue?vue&type=script&lang=js&"
import style0 from "./PasswordForgot.vue?vue&type=style&index=0&id=40bba02e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bba02e",
  null
  
)

export default component.exports